import { supabase } from '@/lib/supabaseClient';
import type { GenerationStatus, HistoryEntry } from '@/types/history';

import { getSignedImageUrls } from './storage';

interface RawImage {
  storage_path: string;
  position: number;
}

interface RawHistoryRow {
  id: string;
  collection_id: string;
  selections: Record<string, string[]>;
  status: GenerationStatus;
  created_at: string;
  generation_images: RawImage[];
}

function pickFirstImage(images: RawImage[]): RawImage | undefined {
  return [...images].sort((a, b) => a.position - b.position)[0];
}

/** RLS уже ограничивает выборку своим user_id — фильтр по нему тут избыточен. */
export async function fetchHistory(): Promise<HistoryEntry[]> {
  if (!supabase) {
    return [];
  }

  const { data, error } = await supabase
    .from('generations')
    .select('id, collection_id, selections, status, created_at, generation_images(storage_path, position)')
    .order('created_at', { ascending: false })
    .returns<RawHistoryRow[]>();

  if (error) {
    throw new Error('Не удалось загрузить историю.');
  }

  const rows = data ?? [];

  const firstImagePaths = rows
    .map((row) => pickFirstImage(row.generation_images)?.storage_path)
    .filter((path): path is string => Boolean(path));

  const signedUrls = await getSignedImageUrls(firstImagePaths);

  return rows.map((row) => {
    const firstImage = pickFirstImage(row.generation_images);

    return {
      id: row.id,
      collectionId: row.collection_id,
      status: row.status,
      createdAt: row.created_at,
      selections: row.selections,
      thumbnailUrl: firstImage ? (signedUrls.get(firstImage.storage_path) ?? null) : null,
    };
  });
}
